import React from "react";
import styles from "./about.module.css";
// import { MdOutlineArrowOutward } from "react-icons/md";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { Col, Container, Row } from "react-bootstrap";
import { LightBgButton } from "../Buttons/LightBgButton";
import { ActionButtonPrimary } from "../Buttons/ActionButtonPrimary";

const AboutSection = ({handleShow}) => {
  return (
    <React.Fragment>
      <div className={styles.main_section} id="about">
        <Container>
          <div className={styles.aboutChild}>
            <div>
              <LightBgButton label={'About Us'} bg="#CCD7FF" color="var(--primary-color)" />
              <Heading>Your Technology Growth Partner</Heading>
              <Paragraph>
                We provide custom software, UI/UX, and cloud solutions to <br /> startups, enterprises, and businesses of all sizes.
              </Paragraph>
            </div>
            <ActionButtonPrimary label={'Book a Consultation'} action={handleShow} />
          </div>
          <Row>
            <Col md={4} sm={12}>
              <div>
                <img src="/images/Homepage/frame_4.png" 
                alt="End-to-end Software Development - BuildShell" />
              </div>
            </Col>
            <Col md={4} sm={12}>
              <div>
                <img src="/images/Homepage/frame_2.png" 
                alt="Beautifull, intuitive UI/UX designs - BuildShell" />
              </div>
            </Col>
            <Col md={4} sm={12}>
              <div>
                <img src="/images/Homepage/frame_3.png" 
                alt="AI & Cloud based solutions - BuildShell" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AboutSection;
